import { useEffect } from 'react'

interface WebgainsTrackingOptions {
  /**
   * If set to `true`, script will be loaded.
   * Defaults to false.
   **/
  hasUserConsent?: boolean
  /**
   * The Webgains Program ID.
   **/
  programId?: string
}

/**
 * Webgains landing page tracking script hook.
 */
export const useWebgainsLandingPageTracking = (
  options?: WebgainsTrackingOptions,
) => {
  useEffect(() => {
    const hasUserConsent = Boolean(options?.hasUserConsent)
    const programId = options?.programId

    if (!hasUserConsent || !programId) {
      return
    }

    // Set variables
    window.ITCLKQ =
      window.ITCLKQ ||
      function (...args: unknown[]) {
        window.ITCLKQ?.q?.push(args)
      }
    window.ITCLKQ.q = window.ITCLKQ.q || []
    window.ITCLKQ.l = new Date().getTime()

    // Load script
    const script = document.createElement('script')
    script.async = true
    script.src = `https://analytics.webgains.io/${programId}/main.min.js`
    const firstScript = document.getElementsByTagName('script')[0]
    firstScript.parentNode?.insertBefore(script, firstScript)

    // Trigger events
    window.ITCLKQ('set', 'internal.api', true)
    window.ITCLKQ('set', 'internal.cookie', true)
    window.ITCLKQ('click')
  }, [options])
}
